module.exports = __webpack_public_path__ + "assets/abd54ffffa9ddd5402f74f06495b1217.mp3";